import { Span } from '@tblabs/truffle';
import { Page } from './Page';
import { Translations } from '../Translations/Translations';


export class DefaultPage extends Page
{
    constructor(_lang: Translations)
    {
        super(_lang.NothingHere);

        this.body.Append(
            new Span(_lang.RedirectingToLoginPage).Color("#666").FontSize(18).MarginLeft(12).Background("#eee"));

        setTimeout(() =>
        {
            window.location.hash = "login";
        }, 1000);
    }
}
